import React from 'react';
import { FiEye } from 'react-icons/fi';
import AiWatchDashboard from '../components/aiWatch/AiWatchDashboard';
import './AiWatch.css';

const AiWatch = () => (
  <div className="ai-watch-page list-page">
    <div className="page-header">
      <h1><FiEye /> AI Watch</h1>
    </div>
    <p className="ai-watch-intro">
      Monitor all AI provider calls across the app — live queue, running jobs, token usage, and per-user activity.
    </p>
    <AiWatchDashboard />
  </div>
);

export default AiWatch;
